import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  employeeDetails: null,
  itemsCount: 0,
  pages: 0,
  error: null
}

export const getEmployees = createAsyncThunk(
  "employees/getEmployees",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axiosInstance.get(
        `/employees?page=${page}&size=${size}&query=${query}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createEmployee = createAsyncThunk(
  "employees/createEmployee",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/employees`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateEmployee = createAsyncThunk(
  "employees/updateEmployee",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/employees/${args._id}`,
        args.values,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteEmployee = createAsyncThunk(
  "employees/deleteEmployee",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(
        `/employees/${args._id}`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const employeesSlice = createSlice({
  name: "employees",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getEmployees.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getEmployees.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.data || [];
        state.itemsCount = payload.data?.itemsCount || 0;
        state.pages = payload.data?.pages || 0;
        state.error = null;
      })
      .addCase(getEmployees.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message
      })

      .addCase(createEmployee.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createEmployee.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createEmployee.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateEmployee.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateEmployee.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateEmployee.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteEmployee.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteEmployee.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteEmployee.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default employeesSlice.reducer;